import type { ResolutionCsvUploadResponse } from '@library/types/resolutions/resolutionDetails';

export const transformResolutionCsvUploadData = ({
  data
}: ResolutionCsvUploadResponse) => {
  const { id: resolutionId } = data;

  return {
    resolutionId
  };
};
